<template>
  <div>
    <div class="w-100 d-inline-block pets-service-bg-image padding-bottom-3 position-relative">
      <div class="container autoContent">
        <div class="row margin-top-4">
          <div class="col-xl-6 col-12">
            <div class="w-100 d-inline-block">
              <span class="nav-color fw-bold text-size-14 family-filson-bold text-full-13">OUR SERVICES</span>
              <h2 class="half-black fw-bold text-full-20 family-filson-bold margin-top-2 text-size-20 margin-bottom-2">
                Professional mobile pet grooming
              </h2>
              <p class="text-size-14 text-black mb-0 family-inter-light text-full-12">
                Dubai Pet Groomers stands proudly behind its vision of making pet grooming comprehensive, affordable, and accessible to all so that your pets live healthy and happy lives.
              </p>
            </div>
            <div class="row margin-top-3 row-scroll mb-xl-0 mb-4">
              <div class="col-xl-6 col-9 margin-bottom-2 col-sm-6 col-md-3 col-lg-3 pe-xs-2">
                <div class="w-100 d-inline-block rounded-4 padding-1 bg-introduction book-pet-service">
                  <div class="float-start pet-service-image w-35">
                    <img class="w-100" src="@/assets/images/pet-dog.webp" alt="pet grooming equipment, pet grooming franchise" />
                  </div>
                  <div class="w-60 pet-service-name float-end w-small-55">
                    <p class="mb-0 half-black fw-bold text-size-14 w-60 family-filson-bold w-xs-50 text-full-13 margin-top-2">
                      DOGS Grooming
                    </p>
                    <p class="text-black text-size-14 mb-2 family-inter-light related-content text-full-11">
                      Trust us with your doggy, and we will groom it with perfection.
                    </p>
                    <router-link class="fw-bold text-size-14 nav-color inter-bold-family mb-3 d-inline-block text-full-13" to="/services/mobile-dog-grooming-dubai-pet-groomer/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-9 margin-bottom-2 col-sm-6 col-md-3 col-lg-3 ps-xs-2">
                <div class="w-100 d-inline-block book-cat-service rounded-4 padding-1 bg-introduction">
                  <div class="float-start pet-service-image w-35">
                    <img class="w-100" src="@/assets/images/pet-grooming-prices-pet-groming-salon.webp" alt="pet grooming prices, pet groming salon" />
                  </div>
                  <div class="w-60 pet-service-name float-end w-small-55">
                    <p class="mb-0 half-black fw-bold text-size-14 w-60 family-filson-bold w-xs-50 text-full-13 margin-top-2">
                      CATS Grooming
                    </p>
                    <p class="text-black text-size-14 family-inter-light related-content mb-2 
                    text-full-11">
                      A well-groomed cat means a happy cat, and a happy cat means happy you.
                    </p>
                    <router-link class="fw-bold text-size-14 nav-color inter-bold-family mb-3 d-inline-block text-full-13" to="/services/mobile-cat-grooming-service-dubai/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-9 margin-bottom-2 col-sm-6 col-md-3 col-lg-3 pe-xs-2">
                <div class="w-100 d-inline-block book-birds-service rounded-4 padding-1 bg-introduction">
                  <div class="float-start pet-service-image w-35">
                    <img class="w-100" src="@/assets/images/pet-birds.webp" alt="grooming at home, grooming for all pets" />
                  </div>
                  <div class="w-60 pet-service-name float-end w-small-55">
                    <p class="mb-0 half-black fw-bold text-size-14 w-60 family-filson-bold w-xs-50 text-full-13 margin-top-2">
                      BIRDS Grooming
                    </p>
                    <p class="text-black text-size-14 mb-2 family-inter-light related-content text-full-11">
                      We keep your furry partners happy, clean, and groomed.
                    </p>
                    <router-link class="fw-bold text-size-14 inter-bold-family nav-color mb-3 d-inline-block text-full-13" to="/services/bird-grooming-services-dubai-pet-groomer/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="col-xl-6 col-9 margin-bottom-2 col-sm-6 col-md-3 col-lg-3 ps-xs-2">
                <div class="w-100 d-inline-block book-rabbit-service rounded-4 padding-1 bg-introduction">
                  <div class="float-start pet-service-image w-35">
                    <img class="w-100" src="@/assets/images/pet-rabbit.webp" alt="professional grooming team, hygienic pet grooming" />
                  </div>
                  <div class="w-60 pet-service-name float-end w-small-55">
                    <p class="mb-0 half-black fw-bold text-size-14 w-60 family-filson-bold w-xs-50 text-full-13 margin-top-2">
                      Rabbits Grooming
                    </p>
                    <p class="text-black text-size-14 mb-2 family-inter-light related-content text-full-11">
                      All it takes is a little trimming anda  bath for a picture-perfect pet.
                    </p>
                    <router-link class="fw-bold text-size-14 inter-bold-family nav-color mb-3 d-inline-block text-full-13" to="/services/rabbit-grooming-dubai-mobile-pet-groomer/">
                      Book Now
                      <i class="fa fa-arrow-right ms-1" aria-hidden="true"></i>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-12">
            <div class="w-100 d-inline-block bg-servics-job">
                <div class="w-100 d-inline-block position-relative mt-xl-0 mt-4">
              <div class="w-100 d-inline-block padding-xl-left-4">
                <span class="nav-color fw-bold text-size-14 text-uppercase family-filson-bold text-full-13">We love our Job! </span>
                <h2 class="half-black fw-bold text-full-20 family-filson-bold margin-top-2 text-size-20 margin-bottom-2">
                  We Provide Best pet grooming Services For Your Pet's
                </h2>
                <p class="text-size-14 text-black mb-0 family-inter-light text-full-12">
                  We are dedicated to delivering professional pet grooming services that combine compassion, convenience, and care, ensuring your pets remain healthy, well-groomed, and truly valued.
                </p>
              </div>
              <div class="row margin-top-3 padding-xl-left-4">
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Haircuts And Styling
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-2.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Face, Ear, Eye Cleaning
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-3.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Nail Trimming And Clipping
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-4.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Shower shampoo and Conditioner
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-5.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11 d-inline-block margin-top-2">
                        Paw Trim
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-6.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Perfumes Spray And Powder
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-7.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Blow drying And Hairbrush
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-8.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Teeth Brushing And Oral Care
                      </span>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-6 margin-bottom-2 col-sm-3 col-md-3 col-lg-3">
                  <div class="w-100 d-inline-block cut-service-icon">
                    <div class="float-start">
                      <img src="@/assets/images/cut-service-icon-image-9.svg" alt="" />
                    </div>
                    <div class="float-end w-75 line-height-17">
                      <span class="half-black text-size-14 family-filson-medium text-full-11">
                        Anal Gland Expression
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row padding-xl-left-4 row-scroll margin-top-3">
                <div class="col-xl-4 col-5 col-sm-4 col-md-4 pe-xs-2">
                  <div class="w-100 d-inline-block bg-white box-shadow rounded-4 top-grooming-box padding-2 text-center border-color">
                    <span class="d-inline-block rounded-5 bg-top-groom-box margin-top-2">
                      <img src="@/assets/images/top-groom-icon.svg" alt="" />
                    </span>
                    <div class="w-100 d-inline-block text-center">
                      <p class="mb-xl-0 mb-1 text-size-14 fw-bold half-black mt-1 text-uppercase family-filson-bold 
                      text-full-13">
                        Top<br>Groomers
                      </p>
                    </div>
                    <p class="text-black text-size-14 service-text family-inter-light text-full-11 margin-bottom-2">
                      The grooming service provided by our qualified staff is remarkable.
                    </p>
                  </div>
                </div>
                <div class="col-xl-4 col-5 col-sm-4 col-md-4 pe-xs-2 ps-xs-2">
                  <div class="w-100 d-inline-block bg-white box-shadow rounded-4 top-grooming-box padding-2 text-center border-color">
                    <span class="d-inline-block rounded-5 bg-top-groom-box margin-top-2">
                      <img src="@/assets/images/vip-service-icon.svg" alt="" />
                    </span>
                    <div class="w-100 d-inline-block text-center">
                      <p class="mb-xl-0 mb-1 text-size-14 fw-bold half-black mt-1 text-uppercase family-filson-bold 
                      text-full-13">
                        V.I.P.<br>Service
                      </p>
                    </div>
                    <p class="text-black text-size-14 service-text family-inter-light text-full-11 margin-bottom-2">
                      We take pride in providing individualised care for both you and your pet.
                    </p>
                  </div>
                </div>
                <div class="col-xl-4 col-5 col-sm-4 col-md-4 pe-xs-2 ps-xs-2">
                  <div class="w-100 d-inline-block bg-white box-shadow rounded-4 top-grooming-box padding-2 text-center border-color">
                    <span class="d-inline-block rounded-5 bg-top-groom-box margin-top-2">
                      <img src="@/assets/images/every-pet-icon.svg" alt="" />
                    </span>
                    <div class="w-100 d-inline-block text-center">
                      <p class="mb-xl-0 mb-1 text-size-14 fw-bold half-black mt-1 text-uppercase family-filson-bold 
                      text-full-13 service-under-heading">
                        We Love<br>Every Pet
                      </p>
                    </div>
                    <p class="text-black text-size-14 service-text family-inter-light text-full-11 margin-bottom-2">
                      Since we adore all animals, your pet will be calm and stress-free.
                    </p>
                  </div>
                </div>
              </div>
          </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "ourServicesComponent",
  };
</script>

<style scoped></style>
